"use strict";

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReverseIterator_1 = require("./ReverseIterator");

var comparators_1 = require("../../functional/comparators");
/**
 * Iterator of Array Containers.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var ArrayIteratorBase =
/** @class */
function () {
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */

  /**
   * Initializer Constructor.
   *
   * @param source Source container.
   * @param index Index number.
   */
  function ArrayIteratorBase(array, index) {
    this.array_ = array;
    this.index_ = index;
  }
  /**
   * @internal
   */


  ArrayIteratorBase.prototype._Get_array = function () {
    return this.array_;
  };
  /**
   * @inheritDoc
   */


  ArrayIteratorBase.prototype.index = function () {
    return this.index_;
  };

  Object.defineProperty(ArrayIteratorBase.prototype, "value", {
    /**
     * @inheritDoc
     */
    get: function get() {
      return this.array_.at(this.index_);
    },

    /**
     * @inheritDoc
     */
    set: function set(val) {
      this.array_.set(this.index_, val);
    },
    enumerable: true,
    configurable: true
  });
  /* ---------------------------------------------------------
      MOVERS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */

  ArrayIteratorBase.prototype.prev = function () {
    return this.advance(-1);
  };
  /**
   * @inheritDoc
   */


  ArrayIteratorBase.prototype.next = function () {
    return this.advance(1);
  };
  /**
   * @inheritDoc
   */


  ArrayIteratorBase.prototype.advance = function (n) {
    return this.array_.nth(this.index_ + n);
  };
  /* ---------------------------------------------------------
      COMPARES
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  ArrayIteratorBase.prototype.equals = function (obj) {
    return comparators_1.equal_to(this.array_, obj.array_) && this.index_ === obj.index_;
  };

  return ArrayIteratorBase;
}();

exports.ArrayIteratorBase = ArrayIteratorBase;
/**
 * Reverse iterator of Array Containers.
 *
 * @author Jeongho Nam <http://samchon.org>
 */

var ArrayReverseIteratorBase =
/** @class */
function (_super) {
  __extends(ArrayReverseIteratorBase, _super);

  function ArrayReverseIteratorBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  ArrayReverseIteratorBase.prototype.advance = function (n) {
    return this._Create_neighbor(this.base().advance(-n));
  };
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  ArrayReverseIteratorBase.prototype.index = function () {
    return this.base_.index();
  };

  Object.defineProperty(ArrayReverseIteratorBase.prototype, "value", {
    /**
     * @inheritDoc
     */
    get: function get() {
      return this.base_.value;
    },

    /**
     * @inheritDoc
     */
    set: function set(val) {
      this.base_.value = val;
    },
    enumerable: true,
    configurable: true
  });
  return ArrayReverseIteratorBase;
}(ReverseIterator_1.ReverseIterator);

exports.ArrayReverseIteratorBase = ArrayReverseIteratorBase;